import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-20 px-4 bg-brandGreen text-navy relative overflow-hidden" data-id="element-166">
      {/* Background decoration */}
      <div className="absolute -top-24 -right-24 w-64 h-64 bg-white/20 rounded-full blur-3xl" data-id="element-167"></div>
      <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-white/20 rounded-full blur-3xl" data-id="element-168"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl text-center border-4 border-navy/5" data-id="element-170">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-24 md:h-24 bg-brandGreen/10 rounded-full mb-6 md:mb-8" data-id="element-171">
            <ShieldCheck className="w-8 h-8 md:w-12 md:h-12 text-brandGreen" data-id="element-172" />
          </div>

          <h2 className="text-2xl md:text-5xl font-black text-navy mb-4 md:mb-8" data-id="element-173">
            GARANTÍA FÚTBOL FEMENINO RESUELTO — 7 DÍAS
          </h2>

          <p className="text-base md:text-2xl text-gray-700 font-medium leading-relaxed mb-6 md:mb-8" data-id="element-174">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu entrenamiento
            si querés. Si en 7 días no es lo que esperabas: Te devolvemos el
            100%. Sin preguntas. Sin formularios. Sin drama.
          </p>

          <div className="bg-gray-50 p-4 md:p-6 rounded-2xl border border-gray-200" data-id="element-175">
            <p className="text-sm md:text-base text-gray-600 font-medium" data-id="element-176">
              La confianza que tenemos en FÚTBOL FEMENINO RESUELTO nos permite
              hacer esa promesa sin dudar. Más de 300 entrenadores de fútbol
              femenino de todo el país ya lo saben. La tasa de devoluciones es
              menor al 1%.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}